import classNames from "classnames";

interface SpacerProps {
  className?: string;
  isThick?: boolean;
}

const Spacer = (props: SpacerProps) => {
  const { className, isThick } = props;

  const cls = classNames("scha__spacer", className, {
    "scha__spacer--thick": isThick,
  });

  return <hr className={cls} />;
};

export default Spacer;
